<!-- =========================================================
     Start Short Course List
========================================================= -->

<div class="ecb-web-public-page" *ngIf="isMainComponent">

    <!-- Start Short Courses List Banner Section -->
    <section class="ecb-web-short-courses-list-banner-section">

        <!-- Start Short Courses List Banner Overlay -->
        <div class="ecb-web-short-courses-list-banner-overlay"></div>
        <!-- End Short Courses List Banner Overlay -->

        <div class="container ecb-web-short-courses-list-banner-container">

            <div class="row align-items-center">

                <!-- Start Short Courses List Banner Content -->
                <div class="col-12 col-lg-12">

                    <!-- =====================================================
                         Heading
                    ====================================================== -->

                    <div class="ecb-x-course-list-heading-2">



                        <!-- VOC Title -->
                        <ng-container>
                            <div class="ecb-web-hsr-banner-content">

                                <span class="ecb-web-hsr-banner-label">

                                </span>
                                <span class="pill">ECB Training</span>

                                <h1>
                                    Verification of Competency
                                </h1>
                                <div class="ecb-web-short-title-line"></div>
                                <p>
                                    Browse our Verification of Competency assessments.
                                    Select an assessment to view detailed information,<br>
                                    required documents and enquiry options.
                                </p>


                            </div>

                        </ng-container>




                    </div>


                </div>

            </div>

        </div>

    </section>
    <!-- End Short Courses List Banner Section -->

</div>


<section class="ecb-x-course-list-section" id="short-course-list">


    <div class="container">


        <!-- =====================================================
             Heading
        ====================================================== -->

        <div class="ecb-x-course-list-heading">


            <!-- VOC Title -->

            <ng-container>

                <h1>
                    Verification of Competency
                </h1>

                <p>
                    Browse our Verification of Competency assessments.
                    Select an assessment to view detailed information,
                    required documents and enquiry options.
                </p>

            </ng-container>


        </div>


        <!-- =====================================================
             Loading
        ====================================================== -->

        <div class="ecb-x-course-loading" *ngIf="isLoading">

            <div class="spinner-border" role="status">
            </div>

            <span>
                Loading courses...
            </span>

        </div>


        <!-- =====================================================
             Course Grid
        ====================================================== -->

        <div class="row g-4" *ngIf=" !isLoading &&   paginatedCourses.length > 0 ">


            <div class="col-12 col-sm-6 col-lg-4 col-xl-3" *ngFor="  let course of paginatedCourses  ">


                <!-- Course Card -->

                <article class="ecb-x-course-card" tabindex="0" (click)="openCourseDetails(course)"
                    (keyup.enter)="openCourseDetails(course)">


                    <!-- =================================================
                 Image
            ================================================== -->

                    <div class="ecb-x-course-image-wrapper">


                        <!-- Actual Image -->

                        <img *ngIf="hasCourseImage(course)" [src]="course.imageUrl" [alt]="getCourseTitle(course)"
                            class="ecb-x-course-image" (error)="onImageError(course)">


                        <!-- Image Fallback -->

                        <div class="ecb-x-course-image-fallback" *ngIf="!hasCourseImage(course)">

                            <div class="ecb-x-course-fallback-icon">

                                <i class="bi bi-mortarboard"></i>

                            </div>

                            <span>
                                ECB Training
                            </span>

                        </div>


                        <!-- Course Type Badge -->

                        <!--   <span class="ecb-x-course-image-badge">

                  {{ courseType }}

                </span> -->

                    </div>


                    <!-- =================================================
                 Content
            ================================================== -->

                    <div class="ecb-x-course-card-content">


                        <!-- Code -->

                        <!--  <span class="ecb-x-course-code">

                             {{ getCourseCode(course) }}

                           </span>
                -->

                        <!-- Title -->

                        <h3>

                            {{ getCourseTitle(course) }}

                        </h3>


                        <!-- Description -->

                        <div class="ecb-x-course-description ecb-x-details-rte-list"
                            [innerHTML]="getCourseDescription(course) | safeHtml">



                        </div>


                        <!-- Price -->
                        <!-- 
                        <div class="ecb-x-course-price">

                            {{ getPrice(course) }}

                        </div>
 -->

                        <!-- View Details -->

                        <button type="button" class="btn ecb-x-course-view-button" (click)="
                openCourseDetails(course);
                $event.stopPropagation()
              ">

                            <span>
                                View Course
                            </span>

                            <i class="bi bi-arrow-right"></i>

                        </button>

                    </div>

                </article>

            </div>

        </div>


        <!-- =====================================================
             No Courses
        ====================================================== -->

        <div class="ecb-x-course-empty" *ngIf="
       
        !isLoading &&
        courses.length === 0
      ">

            <div class="ecb-x-course-empty-icon">

                <i class="bi bi-journal-x"></i>

            </div>

            <h3>
                No Courses Available
            </h3>

            <p>
                There are currently no courses available
                in this category.
            </p>

        </div>



       

        <!-- =====================================================
             Pagination
        ====================================================== -->

        <div class="ecb-x-course-pagination-wrapper" *ngIf=" !isLoading &&    totalPages > 1 ">

            <ul class="ecb-x-course-pagination">


                <!-- Previous -->

                <li>

                    <button type="button" [disabled]="currentPage === 1" (click)="previousPage()">

                        <i class="bi bi-chevron-left"></i>

                    </button>

                </li>


                <!-- Pages -->

                <li *ngFor="let page of pages">

                    <button type="button" [class.active]="
              currentPage === page
            " (click)="goToPage(page)">

                        {{ page }}

                    </button>

                </li>


                <!-- Next -->

                <li>

                    <button type="button" [disabled]="
              currentPage === totalPages
            " (click)="nextPage()">

                        <i class="bi bi-chevron-right"></i>

                    </button>

                </li>

            </ul>

        </div>

    </div>

</section>

<!-- =========================================================
     End Short Course List
========================================================= -->